import { UserStatus } from "./types"

// 用户状态标签映射
export const UserStatusLabels: Record<UserStatus, string> = {
  [UserStatus.ACTIVE]: "激活",
  [UserStatus.INACTIVE]: "未激活",
}

// 用户状态颜色映射
export const UserStatusColors: Record<UserStatus, string> = {
  [UserStatus.ACTIVE]: "green",
  [UserStatus.INACTIVE]: "red",
}

// 用户编码验证规则常量
export const USER_CODE_VALIDATION = {
  /** 用户编码最小长度 */
  MIN_LENGTH: 3,
  /** 用户编码最大长度 */
  MAX_LENGTH: 20,
  /** 用户编码正则表达式（只允许英文、数字、下划线） */
  PATTERN: /^[a-zA-Z0-9_]+$/,
  /** 最小长度错误消息 */
  MIN_MESSAGE: "用户编码至少3个字符",
  /** 最大长度错误消息 */
  MAX_MESSAGE: "用户编码不能超过20个字符",
  /** 格式错误消息 */
  PATTERN_MESSAGE: "用户编码只能包含英文、数字和下划线",
  /** 必填错误消息 */
  REQUIRED_MESSAGE: "请输入用户编码",
} as const

// 用户名验证规则常量
export const USER_NAME_VALIDATION = {
  /** 用户名最大长度 */
  MAX_LENGTH: 50,
  /** 最大长度错误消息 */
  MAX_MESSAGE: "用户名不能超过50个字符",
  /** 必填错误消息 */
  REQUIRED_MESSAGE: "请输入用户名",
} as const
